<span class="default-icon" *ngIf="defaultIcon && !avatarUrl">
  {{ defaultIcon }}
</span>
<span class="user-icon" *ngIf="icon && !avatarUrl">
  {{ icon }}
</span>
<img class="default-icon avatar" *ngIf="avatarUrl" [src]="avatarUrl" [alt]="userName" />
